import styled from 'styled-components';
import { s } from './VIPReport.style';

const BasicInformation = () => {
  return (
    <s.Div>
      <s.Title>🔎기본 정보 요약</s.Title>
      <s.Table>
        <s.TableHeader>
          <s.Header width="160px">항목</s.Header>
          <s.Header width="calc(100% - 160px)">금액</s.Header>
        </s.TableHeader>
        <s.Row>
          <RowLeft>감정가</RowLeft>
          <RowRight>금액</RowRight>
        </s.Row>
        <s.Row>
          <RowLeft>최저 입찰가</RowLeft>
          <RowRight>금액</RowRight>
        </s.Row>
        <s.Row>
          <RowLeft>예상 낙찰가</RowLeft>
          <RowRight>금액</RowRight>
        </s.Row>
        <s.Row>
          <RowLeft>AI 추정시세</RowLeft>
          <RowRight>금액</RowRight>
        </s.Row>
      </s.Table>
      <s.BottomDescription>
        <div>
          이 물건은 감정가보다 낮게 낙찰이 예상되며,
          <br />
          시세 대비 ▼ 약 27% 저렴하게 매입 가능성이 있습니다.
        </div>
      </s.BottomDescription>
    </s.Div>
  );
};

export default BasicInformation;

const RowLeft = styled.div`
  width: 160px;
  padding: 16px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
  font-size: 14px;
  font-weight: 500;
  color: #222222;
`;

const RowRight = styled.div`
  width: calc(100% - 160px);
  padding: 16px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
  font-size: 14px;
  font-weight: 500;
  color: #222222;
`;
